import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IThemeAxis } from '../models/essay';

interface IEssayCoreState {
  text: string | null;
  image: string | null;
  title: string | null; 
  themeAxis: IThemeAxis[];
  setThemeAxis: (axis: IThemeAxis[]) => void;
  setText: (text: string | null) => void;
  setImage: (url: string | null) => void;
  setTitle: (title: string | null) => void;
  reset: () => void;
}

export const useEssayCoreStore = create<IEssayCoreState>()(
  persist(
    (set) => ({
      text: null,
      image: null,
      title: null,
      themeAxis: [],
      setThemeAxis: (axis: IThemeAxis[]) => set({ themeAxis: axis }),
      setText: (text: string | null) => set({ text: text }),
      setImage: (url: string | null) => set({ image: url }),
      setTitle: (title: string | null) => set({ title: title }),
      reset: () => set({
        text: null,
        image: null,
        title: null,
      })
    }),
    {
      name: 'core-essay-store'
    }
  )
);